import { PreavisInterventionState } from './state';

export enum PreavisInterventionModuleAction {
    GET_LIST = 'GET_LIST',
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    UPDATE_ACTIVATION = 'UPDATE_ACTIVATION',
    DELETE = 'DELETE',
}

export type ActionsArguments = {
    state: PreavisInterventionState;
    commit: any;
    dispatch: any;
    getters: any;
    rootGetters: any;
};
